const pad2 = value => String(value).padStart(2, '0')

export const rosterDateKey = (year, month, index) => {
  const day = Number(index) + 1
  return `${String(year)}-${pad2(month)}-${pad2(day)}`
}

export const isFutureRosterIndex = ({ year, month, index, todayKey }) => (
  rosterDateKey(year, month, index) > todayKey
)

export const isPastRosterIndex = ({ year, month, index, todayKey }) => (
  rosterDateKey(year, month, index) < todayKey
)

export const canApplyScheduledTimes = ({
  year,
  month,
  index,
  todayKey,
  attendance,
  fullTimeId,
  start,
  end,
  startBasic,
  endBasic
}) => {
  if (isFutureRosterIndex({ year, month, index, todayKey })) return false
  if (Number(attendance) !== Number(fullTimeId)) return false
  if (start || end) return false
  return Boolean(startBasic && endBasic)
}

export const backendErrorMessage = (error, fallback) => {
  const message = error && error.response && error.response.data
    ? error.response.data.message
    : ''
  return String(message || fallback || '').trim()
}
